// tslint:disable

import * as React from 'react';
import Select from 'react-select';
import { Field } from '../libs/form.lib';
import { BaseField } from '../libs/input-base';
import { get } from 'lodash';

export class SelectField extends BaseField<any> {
    public field: Field = this.props.field;
    public state: any = {
        value: null,
        isLoading: false,
        disabled: this.field.disabled
    };

    public static StringDecoder(value: any) {
        return get(value, 'value', '').toString();
    }

    public static StringEncoder(value: any) {
        return value;
    }

    private _deepEqual(x: any, y: any) {
        if (x === y) {
            return true;
        }
        else if ((typeof x == "object" && x != null) && (typeof y == "object" && y != null)) {
            if (Object.keys(x).length != Object.keys(y).length)
                return false;

            for (var prop in x) {
                if (y.hasOwnProperty(prop))
                {
                    if (! this._deepEqual(x[prop], y[prop]))
                        return false;
                }
                else
                    return false;
            }

            return true;
        }
        else
            return false;
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        if (this.props.multi && this.props.field.value !== null && (!this._deepEqual(this.state.value, prevState.value) || (prevState.value === null || prevState.value === undefined))) {
            this.field.setValue(this.props.field.value, true, true);
        }

        if (!this.props.multi && this.props.field.value !== prevProps.field.value) {
            this.field.setValue(this.props.field.value, true, true);
        }
    }

    componentWillMount() {
        this.field.registerField();

        this.field.onValueChanges$.subscribe((values) => {
            this.setState({
                value: this.encode(values)
            });
        });
    }

    public onValueChange(event: any) {
        this.setState({
            value: event
        });

        this.field.setValue(this.decode(event), false, false);
        // console.log(this.field, this.field.getValue())
    }

    public decode(values: any) {
        if (this.props.decode) {
            return this.props.decode(values);
        }
        if (this.props.multi) {
            return (values || []).map((i: any) => {
                return i.value;
            });
        } else {
            return values.value;
        }
    }

    public encode(values: any) {
        if (this.props.encode) {
            return this.props.encode(values);
        }
        if (this.props.multi) {
            return (values || []).map((i: any) => {
                return {
                    value: i,
                    label: i.toString()
                }
            });
        } else {
            return values;
        }
    }

    render() {
        return (



            <div className={this.props.className} id={this.uid}>
                <div className="form-group">
                    <label htmlFor={this.uid + '_input'}>{this.props.title || this.field.title}</label>
                    <div className={'input-group' + (this.state.disabled && ' disabled')}>
                        <Select
                            className="iri-error-fixer"
                            value={this.state.value}
                            options={this.props.options || []}
                            onChange={(event: any) => this.onValueChange(event)}
                            multi={(typeof this.props.multi === 'undefined') ? this.field.multi : this.props.multi}
                        />
                    </div>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/fields/select.field.tsx